// Pain Signal Funnel - Campaign Keys by Score Tier
// Maps source + score tier to Leadspedia campaign credentials

const CAMPAIGN_KEYS = {
  // JEM affiliate
  'jem': {
    hot: {
      lp_campaign_id: '697cb0423f665',
      lp_campaign_key: 'fqVKQdGPN2b3W4M6LznH'
    },
    warm: {
      lp_campaign_id: '697cb07b9839d',
      lp_campaign_key: '69HJjK2hc7fLF3kM4Cdy'
    },
    cool: {
      lp_campaign_id: '697cb0a9dccc7',
      lp_campaign_key: '4NjcPHvgrwW873dVQFpt'
    },
    cold: {
      lp_campaign_id: '697cb0dc04df6',
      lp_campaign_key: '9DFR62kW43rwQVPtBgJj'
    }
  },
  // Default fallback (uses JEM keys)
  'default': {
    hot: {
      lp_campaign_id: '697cb0423f665',
      lp_campaign_key: 'fqVKQdGPN2b3W4M6LznH'
    },
    warm: {
      lp_campaign_id: '697cb07b9839d',
      lp_campaign_key: '69HJjK2hc7fLF3kM4Cdy'
    },
    cool: {
      lp_campaign_id: '697cb0a9dccc7',
      lp_campaign_key: '4NjcPHvgrwW873dVQFpt'
    },
    cold: {
      lp_campaign_id: '697cb0dc04df6',
      lp_campaign_key: '9DFR62kW43rwQVPtBgJj'
    }
  }
}

// Get campaign keys for a source and score tier
export function getCampaignKeysByTier(sourceId, tier) {
  const sourceConfig = CAMPAIGN_KEYS[sourceId] || CAMPAIGN_KEYS['default']
  return sourceConfig[tier] || sourceConfig['cold']
}

// Get all available source IDs
export function getAvailableSources() {
  return Object.keys(CAMPAIGN_KEYS).filter(k => k !== 'default')
}

// Legacy export for compatibility (used in some services)
export const campaignKeys = CAMPAIGN_KEYS

// No EMP mode in pain signal funnel
export const FORCE_EMP_AIDS = []
export const EMP_SPLIT_AIDS = []
export const EMP_SPLIT_KEYS = {}
export const DISCLAIMER_AIDS = []
export const DIRECT_LINK_AFFS = []
export const DOMAIN_AFF_MAPPING = {}

// Legacy helper (returns default hot tier for compatibility)
export function getCampaignKeysForAff(affId) {
  return getCampaignKeysByTier(affId, 'hot')
}
